import { gql } from '@apollo/client';

export default class FormsQuery {
    static GET_FORM_PACKS = gql`
        query getFormPacks($lotId: Int!) {
            getFormPacks(lotId: $lotId) {
                packId
                packName
                lotName
                lotId
            }
        }
    `;

    static GET_FORM_BY_FORM_PACKS = gql`
        query getFormByFormPacks($packId: Int!, $sortBy: String) {
            getFormByFormPacks(packId: $packId, sortBy: $sortBy) {
                id
                formId
                commonName
                category
                formPrintingType
                originalName
                defaultChecked
            }
        }
    `;

    static GET_ALL_AVAILABLE_FORMS = gql`
        query getAllAvailableForms($lotState: String!, $packId: Int!, $search: String) {
            getAllAvailableForms(lotState: $lotState, packId: $packId, search: $search) {
                id
                formId
                commonName
                originalName
                category
                originalName
                formPrintingType
            }
        }
    `;

    static GET_CUSTOM_FIELD_BY_FORMS = gql`
        query getCustomFieldByForms($forms: [Int!], $dealId: Int!) {
            getCustomFieldByForms(forms: $forms, dealId: $dealId) {
                id
                name
                formId
                originalName
                commonName
                customField {
                    customFieldId      
                    data
                }
                secureCloseMapID,
                secureCloseDocumentName,
            }
        }
    `;

    static GET_SECURE_CLOSE_FORMS_LIST = gql`
        query getSecureCloseFormsList($state: String!) {
            getSecureCloseFormsList(state: $state) {
                id
                formId
                commonName
                originalName
                secureCloseMapID,
                secureCloseDocumentName,
            }
        }
    `;
}
